import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiFolder, FiSearch } from 'react-icons/fi';
import * as folderService from '../../services/folders';
import * as categoryService from '../../services/categories';
import '../../styles/main.scss';

const Folders = () => {
  const [filters, setFilters] = useState({
    search: '',
    categoryId: '',
  });

  const { data: categoriesResponse } = useQuery(
    ['folders-categories'],
    () => categoryService.getCategories({ page: 1, limit: 100 })
  );

  const { data: foldersResponse, isLoading } = useQuery(
    ['folders', filters],
    () =>
      folderService.getFolders({
        search: filters.search || undefined,
        categoryId: filters.categoryId || undefined,
      })
  );

  const categories = categoriesResponse?.categories || categoriesResponse?.data?.categories || [];
  const folders = foldersResponse?.folders || foldersResponse?.data?.folders || [];

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="dashboard-page folders-page">
      <div className="page-header">
        <div>
          <h1>Folders</h1>
          <p>Browse and manage folders within categories</p>
        </div>
      </div>

      <div className="page-content">
        <div className="section-card">
          <div className="folders-filters">
            <div className="search-box">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search folders..."
                value={filters.search}
                onChange={(event) =>
                  handleFilterChange('search', event.target.value)
                }
              />
            </div>
            <select
              className="form-control"
              value={filters.categoryId}
              onChange={(event) =>
                handleFilterChange('categoryId', event.target.value)
              }
            >
              <option value="">All categories</option>
              {categories.map((category) => (
                <option key={category._id} value={category._id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="folders-grid">
            {isLoading ? (
              <div className="loading-placeholder">
                {[...Array(6)].map((_, index) => (
                  <div key={index} className="skeleton skeleton-text" />
                ))}
              </div>
            ) : folders.length === 0 ? (
              <div className="empty-state">
                <FiFolder size={32} />
                <p>No folders found</p>
              </div>
            ) : (
              folders.map((folder) => (
                <motion.div
                  key={folder._id}
                  className="folder-card"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  <Link to={`/folders/${folder._id}`}>
                    <div className="folder-header">
                      <div className="folder-icon">
                        <FiFolder />
                      </div>
                    </div>
                    <div className="folder-body">
                      <h3>{folder.name}</h3>
                      <p className="folder-meta">
                        {folder.categoryId?.name || 'No category'}
                      </p>
                    </div>
                  </Link>
                </motion.div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Folders;
